<template>
  <b-dropdown
    position="is-bottom-left"
    aria-role="menu"
    trap-focus
    class="dropdown-edge-cases"
  >
    <a
      slot="trigger"
      class="button is-small is-danger"
      role="button"
    >
      <b-icon
        icon="alert-outline"
        size="is-small"
      />
      <span>Cas spéciaux</span>
    </a>

    <b-dropdown-item
      aria-role="menu-item"
      :focusable="false"
      custom
      paddingless
    >
      <div class="edge-case-wrapper">
        <div class="edge-case-header">
          <div class="title">
            <span class="icon mr-5">
              <i class="mdi mdi-alert" />
            </span>
            <span>Cette visualisation contient des cas spéciaux</span>
          </div>
        </div>

        <div class="edge-cases">
          <div
            v-for="(edgeCase, i) in edgeCases"
            :key="i" 
            aria-role="listitem"
            class="edge-case"
            @click="$emit('select', onInteraction(edgeCase))"
            @mouseenter="$emit('select', onInteraction(edgeCase))"
            @mouseleave="$emit('select', null)"
          >
            <div
              v-if="edgeCase.type == 'duplicata'"
              class="media"
            >
              <div class="media-left">
                <span class="icon">
                  <i class="mdi mdi-content-copy" />
                </span>
              </div>
              <div class="media-content">
                <b>{{ edgeCase.data[0].title }}</b> est dupliquée car elle est à la fois une inspiration et un influence pour {{ $parent.artist.name }}
              </div>
            </div>
            <div
              v-if="edgeCase.type == 'same_level_source'"
              class="media"
            >
              <div class="media-left">
                <span class="icon">
                  <i class="mdi mdi-arrow-left-right" />
                </span>
              </div>
              <div class="media-content">
                {{ $parent.artist.name }} a été inspiré par deux chansons ayant elles-mêmes une relation d’adaptation. <b>{{ edgeCase.data[0].title }}</b> a été adaptée de <b>{{ edgeCase.data[1].title }}</b>
              </div>
            </div>
            <div
              v-if="edgeCase.type == 'same_level_own'"
              class="media"
            >
              <div class="media-left">
                <span class="icon">
                  <i class="mdi mdi-sync" />
                </span>
              </div>
              <div class="media-content">
                {{ $parent.artist.name }} a adapté une de ses propres chansons. <b>{{ edgeCase.data[0].title }}</b> a été adaptée de <b>{{ edgeCase.data[1].title }}</b>
              </div>
            </div>
          </div>
        </div>
      </div>
    </b-dropdown-item>
  </b-dropdown>
</template>

<script>
export default {
	props: {
		edgeCases: {
			required: true,
			type: Array
		}
	},
	data () {
		return {
			active: false
		};
	},
	methods: {
		toggle () {
			this.active = !this.active;
		},
		onInteraction (edgeCase) {
			return {
				data: edgeCase.data.map(d => d.id), 
				type: edgeCase.type
			};
		}
	}
};
</script>

<style lang="scss">
.dropdown-edge-cases {
  .dropdown-content {
    padding: 0 !important;
  }
}
.edge-case-wrapper {
  background-color: rgba(255,0,0,0.05);
  border-radius: 5px;
  border: 2px solid #d90e00;
  overflow: hidden;
}
.edge-case-header {
  padding: 8px 10px;
  border-bottom: 1px solid #ffb4b0;

  .title {
    font-size: 1rem;
    color: #b90c00;
  }
}
.edge-cases {
  width: 400px;
  max-height: 165px;
  overflow-y: auto;

  .edge-case {
    padding: 5px 5px;
    font-size: 14px;
    cursor: pointer;
    line-height: 1.2;

    &:hover {
      background-color: rgba(255,0,0,0.05);
    }

    .icon {
      color: #850900;
    }
  }
}
</style>